import { Box, TextInput } from '@mantine/core';
import { useTextSelector } from './use-text-selector';
import type { InputProps } from '../../types';
import { useDebouncedDraft } from '../../hooks/use-debounced-draft';
import { Clipboard, Reset } from '@morph-mapper/ui';

export const TextSelector = ({ value, handleChange }: InputProps<string>) => {
  const { handleSetPath, handleClearPath } = useTextSelector(handleChange);

  const inputValue = value ?? '';
  const [draft, setDraft] = useDebouncedDraft(inputValue, handleChange);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Clipboard size={'lg'} mr={'md'} onClick={handleSetPath} />
      {inputValue !== '' && (
        <Reset
          size={'lg'}
          mr={'md'}
          onClick={handleClearPath}
          variant="default"
        />
      )}
      <TextInput
        value={draft}
        onChange={(event) => setDraft(event.target.value)}
        sx={{ flexGrow: 1 }}
      />
    </Box>
  );
};
